import * as Yup from "yup";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import { requestAuth } from "../../components/services/RequestService";
import config from "../../config.json";
import { listaTributos } from "../../utils/constant";
import {
  getAccountIdByCode,
  getAccountIdSubByPlanilla,
  getItemDetails,
  validateArray,
} from "../../utils/validate";
import { Request } from "../../hooks/Request";

export const FormAddPaymentReq = ({
  data,
  onClose,
  reload,
  addTitle = null,
  allowEmpty = false,
  formFields = [],
  refFileIndex = "url",
  initVals = {},
  type,
  subElement,
}) => {
  console.log("🚀 ~ FormAddPaymentReq ~ subElement:", subElement);
  console.log("🚀 ~ FormAddPaymentReq ~ data:", data);
  // const { data: accounts, loading } = Request({
  //   urlApi: `${config.requestURLConta}/api/Account/Filter?isMotion=true`,
  // });

  const initialValuesDets = Object.keys(data).reduce((acc, key) => {
    if (key.startsWith("det_")) {
      acc[key] = data[key] ?? null;
    }
    return acc;
  }, {});

  async function uploadFile(values) {
    if (typeof values[refFileIndex] === "string") {
      onSubmit(values);
    } else if (values[refFileIndex]) {
      let formData = new FormData();
      formData.append("Name", data.label);
      formData.append("File", values[refFileIndex]);
      formData.append("originalName", values[refFileIndex].name);
      formData.append("Status", "verified");
      // formData.append("ProcedureId", field.id);

      await requestAuth("post", "/files", formData)
        .then((res) => {
          onSubmit({
            ...values,
            [refFileIndex]: res.data.url,
          });
        })
        .catch(() => {
          toast.error("Se produjo un error al subir el archivo");
        });
    } else {
      onSubmit(values);
    }
  }

  function editOnSubmit(values) {
    onSubmit(values);
  }

  async function onSubmit(values) {
    const newOptionsKeys = Object.keys(values).filter(
      (key) => key.endsWith("_isNew") && values[key],
    );

    for (const key of newOptionsKeys) {
      const baseKey = key.replace("_isNew", "");

      const fieldConfig = formFields.find((f) => f.name === baseKey);
      if (!fieldConfig || !fieldConfig.urlApi) {
        console.warn(`No se encontró 'urlApi' para el campo '${baseKey}'`);
        continue;
      }

      const parts = fieldConfig.urlApi.split("/");
      const dropdownListLabel = parts[parts.length - 2];

      const valueToCreate = values[baseKey];
      if (valueToCreate) {
        await handleCreateOption(baseKey, valueToCreate, dropdownListLabel);
      }
    }

    const details = {
      subDataId: data.subDataId,
      voucherId: data.voucherId,
      voucherItemId: data.voucherItemId,
    };
    Object.keys(values)
      .filter((key) => key.startsWith("det_"))
      .forEach((key) => {
        details[key] = values[key];
      });

    const payload = {
      ...values,
      details: JSON.stringify(details),
    };
    if (payload.label === "PAGO DE TRIBUTOS ADUANEROS") {
      payload.numVal =
        listaTributos.reduce(
          (sum, item) => sum + Number(details[item.name] || 0),
          0,
        ) || 0;
    }

    // await handleEditVoucher(payload);
    const det = await handleEditProcedure(payload);

    await requestAuth(data.id ? "put" : "post", `procElement`, {
      ...payload,
      details: JSON.stringify(det),
    })
      .then(() => {
        reload();
        onClose();
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  // async function handleEditVoucher(payload) {
  //   if (payload.voucherItemId) {
  //     const voucherId = payload.voucherItemId;
  //     if (subElement.length === 0) {
  //       toast.error("Seleccione al menos un item");
  //       return;
  //     }
  //     const index = subElement.findIndex((obj) => obj.id === payload.id);
  //     const selectedItems = subElement.filter(
  //       (item) => item.voucherItemId === voucherId,
  //     );
  //     selectedItems[index] = payload;
  //     try {
  //       const firstItem = [...selectedItems][0];
  //       const firstItemDetails = getItemDetails(firstItem);
  //       const accountCode = firstItemDetails.det_banco;

  //       const bankAccountId = getAccountIdByCode(accountCode, accounts);

  //       if (!bankAccountId) {
  //         toast.error(
  //           `No se encontró la cuenta bancaria con código: ${accountCode}`,
  //         );
  //         return;
  //       }
  //       const voucherItems = [];
  //       let totalAmount = 0;

  //       for (const item of [...selectedItems]) {
  //         const itemDetails = getItemDetails(item);
  //         const planillaNum = itemDetails.det_nroSolPlanilla;

  //         const accountIdSub = await getAccountIdSubByPlanilla(
  //           planillaNum,
  //           accounts,
  //         );

  //         if (!accountIdSub) {
  //           toast.error(
  //             `No se pudo obtener cuenta para planilla: ${planillaNum}`,
  //           );
  //           continue;
  //         }
  //         const isTributos = item.label === "PAGO DE TRIBUTOS ADUANEROS";

  //         if (isTributos) {
  //           const tributosConMonto = listaTributos.filter(
  //             (tb) => item?.[tb.name] && Number(item?.[tb.name]) > 0,
  //           );
  //           for (const tributo of tributosConMonto) {
  //             voucherItems.push({
  //               debitBs: Number(item?.[tributo.name]),
  //               debitSus: 0,
  //               assetBs: 0,
  //               assetSus: 0,
  //               gloss: `${tributo.label} - ${itemDetails.det_concepto || item.label}`,
  //               accountId: accountIdSub,
  //               typeOfExpense: null,
  //               voucherId: voucherId,
  //               carpeta: null,
  //               percentage: 1,
  //               isDebit: null,

  //               concept: tributo.label,
  //               description: item.det_description,
  //             });
  //           }
  //         } else {
  //           voucherItems.push({
  //             debitBs: item.numVal,
  //             debitSus: 0,
  //             assetBs: 0,
  //             assetSus: 0,
  //             gloss: itemDetails.det_concepto || item.label,
  //             accountId: accountIdSub,
  //             typeOfExpense: null,
  //             voucherId: voucherId,
  //             carpeta: null,
  //             percentage: 1,
  //             isDebit: null,

  //             concept: item.label,
  //             description: item.det_description,
  //           });
  //         }
  //         totalAmount += item.numVal;
  //       }

  //       if (voucherItems.length === 0) {
  //         toast.error("No se pudieron procesar items para el voucher");
  //         return;
  //       }

  //       voucherItems.push({
  //         debitBs: 0,
  //         debitSus: 0,
  //         assetBs: totalAmount,
  //         assetSus: 0,
  //         gloss: `PAGO BANCARIO ${selectedItems.map((item) => `- ${item.stringNumber}`)}`,
  //         accountId: bankAccountId,
  //         description: "",
  //         typeOfExpense: null,
  //         voucherId: voucherId,
  //         carpeta: null,
  //         percentage: 1,
  //         isDebit: null,
  //       });

  //       const voucherDate = new Date().toISOString().split("T")[0];

  //       const voucherData = {
  //         id: voucherId,
  //         num: 0,
  //         exchangeRate: 6.96,
  //         // voucherDate: voucherDate,
  //         coin: "BOB",
  //         checkNum: firstItemDetails.det_nroCheque || "",
  //         canceledTo: null,
  //         checkTo: firstItemDetails.det_chequePara || "",
  //         gloss: `${firstItemDetails.det_concepto || ""}`,
  //         bankId: null,
  //         type: 1,
  //         hojaDeRuta: null,
  //         sucursalId: 0,
  //         bankItemRef: 0,
  //         accountingBoxItemRef: 0,
  //         costCenterId: null,
  //         bookSBRef: 0,
  //         typeDocument: "CHEQUE",
  //         provider: "",
  //         invoice: "",
  //         invoiceNumber: "",
  //         nit: "",
  //         refCode: firstItemDetails.det_nroCptSol || "",
  //         movementType: 1,
  //         isHistoric: false,
  //         isTransfer: false,
  //         items: voucherItems,
  //         paymentMethod: "cheque",
  //         stateAccounts: [],
  //         omitVoucher: false,
  //       };

  //       await requestAuth(
  //         "put",
  //         `${config.requestURLConta}/api/voucher/detail`,
  //         voucherData,
  //       );
  //       // if (handleSuccess) handleSuccess();
  //       // if (onClose) onClose();
  //     } catch (err) {
  //       console.error("❌ Error creating voucher:", err);
  //       console.error("Response:", err.response);
  //       toast.error(
  //         err?.response?.data?.message ||
  //         err.message ||
  //         "Error al crear voucher",
  //       );
  //     } finally {
  //     }
  //   } else if (payload.voucherId) {
  //     const voucherId = payload.voucherId;
  //     const selectedItems = [payload];
  //     try {
  //       const firstItem = [...selectedItems][0];
  //       const firstItemDetails = getItemDetails(firstItem);
  //       const accountCode = firstItemDetails.det_banco;

  //       const bankAccountId = getAccountIdByCode(accountCode, accounts);

  //       if (!bankAccountId) {
  //         toast.error(
  //           `No se encontró la cuenta bancaria con código: ${accountCode}`,
  //         );
  //         return;
  //       }
  //       const voucherItems = [];
  //       let totalAmount = 0;

  //       for (const item of [...selectedItems]) {
  //         const itemDetails = getItemDetails(item);
  //         const planillaNum = itemDetails.det_nroSolPlanilla;

  //         const accountIdSub = await getAccountIdSubByPlanilla(
  //           planillaNum,
  //           accounts,
  //         );

  //         if (!accountIdSub) {
  //           toast.error(
  //             `No se pudo obtener cuenta para planilla: ${planillaNum}`,
  //           );
  //           continue;
  //         }
  //         const isTributos = item.label === "PAGO DE TRIBUTOS ADUANEROS";

  //         if (isTributos) {
  //           const tributosConMonto = listaTributos.filter(
  //             (tb) => item?.[tb.name] && Number(item?.[tb.name]) > 0,
  //           );
  //           for (const tributo of tributosConMonto) {
  //             voucherItems.push({
  //               debitBs: Number(item?.[tributo.name]),
  //               debitSus: 0,
  //               assetBs: 0,
  //               assetSus: 0,
  //               gloss: `${tributo.label} - ${itemDetails.det_concepto || item.label}`,
  //               accountId: accountIdSub,
  //               typeOfExpense: null,
  //               voucherId: voucherId,
  //               carpeta: null,
  //               percentage: 1,
  //               isDebit: null,

  //               concept: tributo.label,
  //               description: payload.det_description,
  //             });
  //           }
  //         } else {
  //           voucherItems.push({
  //             debitBs: item.numVal,
  //             debitSus: 0,
  //             assetBs: 0,
  //             assetSus: 0,
  //             gloss: itemDetails.det_concepto || item.label,
  //             accountId: accountIdSub,
  //             typeOfExpense: null,
  //             voucherId: voucherId,
  //             carpeta: null,
  //             percentage: 1,
  //             isDebit: null,

  //             concept: item.label,
  //             description: payload.det_description,
  //           });
  //         }
  //         totalAmount += item.numVal;
  //       }

  //       if (voucherItems.length === 0) {
  //         toast.error("No se pudieron procesar items para el voucher");
  //         return;
  //       }

  //       voucherItems.push({
  //         debitBs: 0,
  //         debitSus: 0,
  //         assetBs: totalAmount,
  //         assetSus: 0,
  //         gloss: firstItem.det_concepto || firstItem.label,
  //         accountId: bankAccountId,
  //         description: "",
  //         typeOfExpense: null,
  //         voucherId: voucherId,
  //         carpeta: null,
  //         percentage: 1,
  //         isDebit: null,
  //       });

  //       const voucherDate = new Date().toISOString().split("T")[0];

  //       const voucherData = {
  //         id: voucherId,
  //         num: 0,
  //         exchangeRate: 6.96,
  //         // voucherDate: voucherDate,
  //         coin: "BOB",
  //         checkNum: firstItemDetails.det_nroCheque || "",
  //         canceledTo: null,
  //         checkTo: firstItemDetails.det_chequePara || "",
  //         gloss: `${firstItemDetails.det_concepto || ""}`,
  //         bankId: null,
  //         type: 1,
  //         hojaDeRuta: null,
  //         sucursalId: 0,
  //         bankItemRef: 0,
  //         accountingBoxItemRef: 0,
  //         costCenterId: null,
  //         bookSBRef: 0,
  //         typeDocument: "CHEQUE",
  //         provider: "",
  //         invoice: "",
  //         invoiceNumber: "",
  //         nit: "",
  //         refCode: firstItemDetails.det_nroCptSol || "",
  //         movementType: 1,
  //         isHistoric: false,
  //         isTransfer: false,
  //         items: voucherItems,
  //         paymentMethod: "cheque",
  //         stateAccounts: [],
  //         omitVoucher: false,
  //       };

  //       await requestAuth(
  //         "put",
  //         `${config.requestURLConta}/api/voucher/detail`,
  //         voucherData,
  //       );
  //       // if (handleSuccess) handleSuccess();
  //       // if (onClose) onClose();
  //     } catch (err) {
  //       console.error("❌ Error creating voucher:", err);
  //       console.error("Response:", err.response);
  //       toast.error(
  //         err?.response?.data?.message ||
  //         err.message ||
  //         "Error al crear voucher",
  //       );
  //     } finally {
  //     }
  //   } else {
  //   }
  // }

  async function handleEditProcedure(payload) {
    const currentDetails = JSON.parse(payload.details || "{}");
    // if (payload.subDataIds && validateArray(payload.subDataIds)) {
    //   for (const subDataId of payload.subDataIds) {
    //     await requestAuth("delete", `/DataSet/procedure/subData/${subDataId}`);
    //   }
    //   const dropdownResponse = await requestAuth(
    //     "get",
    //     `${config.requestURLConta}/api/Account/subfijo/0?nro=${Number(
    //       payload.det_nroSolPlanilla,
    //     )}`,
    //   );
    //   const subfijo = dropdownResponse.data;
    //   const tributosConMonto = listaTributos.filter(
    //     (tb) => payload?.[tb.name] && Number(payload?.[tb.name]) > 0,
    //   );
    //   const subDataIds = [];
    //   for (const tributo of tributosConMonto) {
    //     const subData = await requestAuth(
    //       "post",
    //       `/dataSet/procedure/${payload.procedureId}/fieldname/a-TributosYOtrosConceptosAduaneros/subdata`,
    //       {
    //         label: `${tributo.label}`,
    //         description: Number(payload?.[tributo.name]),
    //         description2: Number(payload?.[tributo.name]),
    //         description3: subfijo.cuentaContable,
    //         description4: "true",
    //         details: payload.det_description,
    //         refVoucherEgressId:
    //           payload.voucherItemId || payload.voucherId || null,
    //       },
    //     );
    //     subDataIds.push(subData.data.id);
    //   }
    //   const updatedDetails = {
    //     ...currentDetails,
    //     subDataIds: subDataIds,
    //   };
    //   return updatedDetails;
    // } else if (payload.subDataId) {
    //   const dropdownResponse = await requestAuth(
    //     "get",
    //     `${config.requestURLConta}/api/Account/subfijo/0?nro=${Number(
    //       payload.det_nroSolPlanilla,
    //     )}`,
    //   );

    //   const subfijo = dropdownResponse.data;
    //   await requestAuth(
    //     "put",
    //     `/DataSet/procedure/subData/${payload.subDataId}`,
    //     {
    //       label: payload.label,
    //       description: payload.numVal,
    //       description2: payload.numVal,
    //       description3: subfijo.cuentaContable,
    //       description4: "true",
    //       details: payload.det_description,
    //       refVoucherEgressId:
    //         payload.voucherItemId || payload.voucherId || null,
    //     },
    //   );
    //   return currentDetails;
    // } else {
    //   return currentDetails;
    // }
    return currentDetails;
  }

  async function handleCreateOption(fieldName, value, dropdownListLabel) {
    await requestAuth("post", "/dropdown/option", {
      Name: value,
      DropdownListLabel: dropdownListLabel,
    });
  }

  // if (!loading) {
  //   return <div className="">Cargando...</div>;
  // }

  return (
    <div className="mb-6 max-w-md">
      <FormDefault
        // tittle={addTitle || `Adicionar archivo`}
        tittle={initVals.label}
        fields={[
          {
            label: "Despacho",
            name: "procedureId",
            typeInput: "selectAsync",
            urlApi: `procedure/bySelect?procedureTypeId=${type}`,
            value: "id",
            labelOption: "numberString",
          },
          ...formFields
            .filter(
              (item) =>
                item.name !== "numVal" ||
                initVals.label !== "PAGO DE TRIBUTOS ADUANEROS",
            )
            .map((item) =>
              // item.name === "det_nroSolPlanilla" || item.name === "det_banco"
              //   ? {
              //       ...item,
              //       urlApi: `${config.requestURLConta}/api${item.urlApi}`,
              //     }
              //   :
              item,
            ),
          ...listaTributos
            .filter(
              (item) =>
                item.type === type || item.type === initVals.procedureTypeId,
            )
            .filter((_) => initVals.label === "PAGO DE TRIBUTOS ADUANEROS")
            .map((item) => ({
              ...item,
              placeholder: "0",
              typeInput: "number",
              rols: ["ger", "liq", "cont"],
              formConfig: true,
              tableConfig: true,
            })),
        ]}
        initialValues={{
          // tariffItem: field.fieldId === 233 ? data.name || "401" : null,
          url: data.url ?? null,
          description: data.description ?? "",
          number: data.number ?? "",
          name: data.name ?? "",
          amount: data.amount ?? null,
          glosa: data.glosa ?? null,
          // det_nroSolPlanilla: data.det_nroSolPlanilla ?? null,
          // det_chequePara: data.det_chequePara ?? null,
          // det_nroCheque: data.det_nroCheque ?? null,
          // det_banco: data.det_banco ?? null,
          ...initialValuesDets,
          ...initVals,
          det_banco: data.det_banco ?? null,
          det_cuentaId: data.det_cuentaId ?? null,
          det_code: data.det_code ?? null,
          presentation: data.presentation ?? "",
          status: data.status ?? "",
          provider: data.provider ?? "",
          placeOfDelivery: data.placeOfDelivery ?? "",
          dateOfDelivery: data.dateOfDelivery ?? "",
        }}
        validationSchema={Yup.object().shape()}
        onSubmit={(values) =>
          !values[refFileIndex] ||
            (typeof values[refFileIndex] === "string" &&
              values.tariffItem !== "0")
            ? editOnSubmit(values)
            : uploadFile(values)
        }
        buttonName="Registrar"
      />
    </div>
  );
};

export default FormAddPaymentReq;
